module.exports = __webpack_public_path__ + "img/icon_aside_excel4_active.7bbec74a.svg";